// removed by extract-text-webpack-plugin
module.exports = {"descriptionList":"descriptionList___2bPSW","title":"title___-KeXI","term":"term___2U0qZ","detail":"detail___270sW","vertical":"vertical___2JVXZ","descriptionListSmall":"descriptionListSmall___29-GJ","descriptionListLarge":"descriptionListLarge___2VhZc"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/DescriptionList/index.less
// module id = 218
// module chunks = 0 1